import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import ProductsSection from './components/ProductsSection';
import WhatsInsideSection from './components/WhatsInsideSection';
import SocialProofSection from './components/SocialProofSection';
import GuaranteeSection from './components/GuaranteeSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';
import FreeGuideModal from './components/FreeGuideModal';
import FAQSection from './components/FAQSection';
import WhoItsForSection from './components/WhoItsForSection';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="bg-[#0a1628] font-body min-h-screen">
      <Navbar onGetFreeGuide={() => setModalOpen(true)} />
      <HeroSection onGetFreeGuide={() => setModalOpen(true)} />
      <ProblemSection />
      <WhoItsForSection />
      <ProductsSection onGetFreeGuide={() => setModalOpen(true)} />
      <FAQSection />
      <WhatsInsideSection />
      <SocialProofSection />
      <GuaranteeSection />
      <FinalCTASection onGetFreeGuide={() => setModalOpen(true)} />
      <Footer />
      <FreeGuideModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
